// La librería se carga al descargar, para no aumentar la carga inicial.
export const createExcelReport = async ({ title, subtitle, sheets }) => {
  const module = await import("exceljs");
  const ExcelJS = module.default || module;
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "ConnectUs";
  for (const { name, columns, rows } of sheets) {
    const sheet = workbook.addWorksheet(name, {
      views: [{ state: "normal", activeCell: "A1" }],
    });
    sheet.columns = columns.map(column => ({ ...column, header: undefined }));
    sheet.mergeCells(1, 1, 1, columns.length);
    sheet.getCell(1, 1).value = title;
    sheet.getCell(1, 1).font = { bold: true, size: 16, color: { argb: "FF474CE6" } };
    sheet.mergeCells(2, 1, 2, columns.length);
    sheet.getCell(2, 1).value = subtitle;
    sheet.getCell(2, 1).alignment = { wrapText: true, vertical: "middle" };
    sheet.getRow(2).height = 42;
    sheet.getRow(4).values = columns.map(column => column.header);
    sheet.getRow(4).height = 26;
    sheet.getRow(4).eachCell(cell => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF474CE6" } };
    });
    rows.forEach(row => {
      const added = sheet.addRow(row);
      added.alignment = { vertical: "top", wrapText: true };
      added.eachCell(cell => {
        if (added.number % 2) cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFF3F3FF" } };
      });
    });
    sheet.autoFilter = { from: { row: 4, column: 1 }, to: { row: 4 + rows.length, column: columns.length } };
  }
  return workbook.xlsx.writeBuffer();
};

export const downloadExcelReport = async (report) => {
  const buffer = await createExcelReport(report);
  const url = URL.createObjectURL(new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  }));
  const link = document.createElement("a");
  link.href = url;
  link.download = report.filename;
  document.body.appendChild(link);
  try {
    link.click();
  } finally {
    link.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};
